import React, { useState, Component } from 'react';
import { Modal } from 'antd';
import { sagaModal } from 'redux-saga-modal';
const isTenantMode = process.env.APP_MODE === 'tenant';

class ImageViewComponent extends Component {

    render() {
        const  src  = this.props.src;
        return (<img style={{with:"500px",height:"500px"}} src={src}></img>)
    }
}

function ImageViewDialog({
    modal: { name },
    isOpen,
    show,
    update,
    destroy,
    click,
    submit,
    hide,
    showModal,
    updateModal,
    submitModal,
    clickModal,
    hideModal,
    destroyModal,
    ...ownProps
  }) {
    return (
      <Modal
        title={ownProps.title}
        destroyOnClose
        footer={null}
        width={600}
        hide={600}
        style={{ top: '30vh' }}
        visible={isOpen}
        onCancel={hide}
      >
        <ImageViewComponent {...ownProps}  />
      </Modal>
    );
  }
  
  export default sagaModal({
    name: 'IMAGE_VIEW_DIALOG',
  })(ImageViewDialog);
  